import { Navigate, Outlet, useLocation } from "react-router-dom";
import useWrapper from "../../hooks/useWrapper";


export default function RequireAdmin() {
  const { me } = useWrapper();
  const location = useLocation();

  return (
    !!me?.is_admin ? <Outlet /> :
      <Navigate to="/" state={{ from: location }} replace />
  )
}